module.exports = __webpack_public_path__ + "img/hotelsjobs.5348e6a2.svg";